import { render, staticRenderFns } from "./TrashButton.vue?vue&type=template&id=7942d3b7&scoped=true&"
import script from "./TrashButton.vue?vue&type=script&lang=ts&"
export * from "./TrashButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7942d3b7",
  null
  
)

export default component.exports